import React, { Fragment } from 'react'
import Container from '../generic/Container'
import Navbar from './Navbar'
import DashboardRouter from './DashboardRouter'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import BurgerMenu from './BurgerMenu'

const Dashboard = inject('loginStore')(withRouter(observer((props) => {
  const { loginStore } = props
  loginStore.resetState()
  return (
    <Fragment>
      <Navbar />
        <BurgerMenu />
        <Container>
        <DashboardRouter />
      </Container>
    </Fragment>
  )
})))

export default Dashboard



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js